import React, { Component } from 'react';
import { AppContext } from "../context/applicationContext";


class SmallSpinner extends Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
    }

    render() {
        return (
           <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        );
    }
}

export default SmallSpinner;

